import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';
import SecurityMonitor from './components/SecurityMonitor';
import CookieConsent from './components/CookieConsent';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';
import About from './pages/About';
import Leadership from './pages/Leadership';
import Contact from './pages/Contact';
import Careers from './pages/Careers';
import CustomerPortal from './pages/CustomerPortal';
import RemoteSupport from './pages/RemoteSupport';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import TermsConditions from './pages/legal/TermsConditions';
import CookiePolicy from './pages/legal/CookiePolicy';

// Import service pages directly
import ManagedIT from './pages/services/ManagedIT';
import CoManagedIT from './pages/services/CoManagedIT';
import ProfessionalServices from './pages/services/ProfessionalServices';
import ConsultingServices from './pages/services/ConsultingServices';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="min-h-screen bg-white">
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <Features />
                <Testimonials />
                <CTA />
              </>
            } />
            <Route path="/about" element={<About />} />
            <Route path="/leadership" element={<Leadership />} />
            <Route path="/services/managed-it" element={<ManagedIT />} />
            <Route path="/services/co-managed-it" element={<CoManagedIT />} />
            <Route path="/services/professional-services" element={<ProfessionalServices />} />
            <Route path="/services/consulting" element={<ConsultingServices />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/customer-portal" element={<CustomerPortal />} />
            <Route path="/remote-support" element={<RemoteSupport />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
          </Routes>
          <Footer />
          <CookieConsent />
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;